import isEmpty from 'lodash/isEmpty';
import apiClient from 'util/apiClient';
import feathers from 'util/client';

/**
 * Selector to return lobby enable state.
 *
 * @param {any} state - State object.
 * @returns {boolean}
 */
export function getSignedInUser(state) {
  return state['features/login'].user;
}

export function getUserTimezone(user) {
  if (isEmpty(user?.device?.timezone?.timezone)) return 'America/New_York';
  else return user.device?.timezone?.timezone;
}

export async function sendValidateRemoteRequest({ email, code }) {
  try {
    const res = await feathers.authenticate({
      strategy: 'video-window-device',
      email,
      code
    });

    return res;
  } catch (err) {
    throw new Error(err);
  }
}

export async function sendCodeRequest({ email }) {
  try {
    const res = await feathers.authenticate({
      strategy: 'video-window-device',
      email
    });

    return res;
  } catch (err) {
    throw new Error(err);
  }
}

export async function sendValidateDeviceRequest({ code }) {
  try {
    const res = await feathers.authenticate({
      strategy: 'video-window-device',
      activationCode: code
    });

    return res;
  } catch (err) {
    throw new Error(err);
  }
}

export async function sendUserInfoRequest({ url, id, token }) {
  try {
    const res = await apiClient.post(url, {
      id: id,
      token: token
    });

    if (res.ok) {
      return res.json();
    }

    throw new Error('Request not successful');
  } catch (err) {
    throw new Error(err);
  }
}
